import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[680px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Modern%20minimalist%20technology%20platform%20hero%20background%2C%20abstract%20geometric%20shapes%20with%20warm%20orange%20and%20teal%20gradient%20accents%20on%20light%20cream%20surface%2C%20soft%20diffused%20lighting%2C%20clean%20sleek%20professional%20tech%20atmosphere%2C%20subtle%20digital%20particles%20floating%2C%20elegant%20gradient%20overlay%2C%208k%20resolution%2C%20commercial%20photography%20style&width=1920&height=900&seq=hero-bg-91&orientation=landscape"
        alt="91免费版 - 免费软件下载平台"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/25 to-black/40" />

      <div className="relative z-10 w-full max-w-5xl mx-auto px-4 md:px-6 text-center py-20">
        <span className="inline-block px-4 py-1.5 text-xs font-medium rounded-full bg-white/15 backdrop-blur-sm text-white mb-6 whitespace-nowrap">
          100% 免费 · 安全纯净 · 海量资源
        </span>

        <h1 className="text-4xl md:text-6xl lg:text-7xl font-heading font-bold text-white mb-6 leading-tight">
          发现你的
          <span className="text-primary-400">理想工具</span>
          <br />
          从这里开始
        </h1>

        <p className="text-base md:text-lg text-white/80 max-w-2xl mx-auto mb-10 leading-relaxed">
          91免费版汇聚数千款优质免费软件，覆盖八大核心分类。无需付费，即刻畅享全部功能。
          安全检测、纯净无捆绑，让每一次下载都安心无忧。
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="#download"
            className="inline-flex items-center px-8 py-3.5 text-base font-semibold whitespace-nowrap rounded-full bg-primary-500 text-white hover:bg-primary-600 transition-all duration-300 cursor-pointer"
          >
            <i className="ri-download-line mr-2" />
            立即免费下载
          </a>
          <Link
            to="/category/system-tools"
            className="inline-flex items-center px-8 py-3.5 text-base font-semibold whitespace-nowrap rounded-full border-2 border-white/30 text-white hover:bg-white/10 transition-all duration-300 cursor-pointer"
          >
            <i className="ri-apps-line mr-2" />
            浏览软件库
          </Link>
        </div>

        <div className="mt-14 flex flex-wrap items-center justify-center gap-8">
          <div className="text-center">
            <p className="text-3xl md:text-4xl font-heading font-bold text-white">3,200+</p>
            <p className="text-sm text-white/60 mt-1">精品软件</p>
          </div>
          <div className="w-px h-10 bg-white/20" />
          <div className="text-center">
            <p className="text-3xl md:text-4xl font-heading font-bold text-white">500万+</p>
            <p className="text-sm text-white/60 mt-1">累计用户</p>
          </div>
          <div className="w-px h-10 bg-white/20" />
          <div className="text-center">
            <p className="text-3xl md:text-4xl font-heading font-bold text-white">99.9%</p>
            <p className="text-sm text-white/60 mt-1">安全通过率</p>
          </div>
          <div className="w-px h-10 bg-white/20" />
          <div className="text-center">
            <p className="text-3xl md:text-4xl font-heading font-bold text-white">8大</p>
            <p className="text-sm text-white/60 mt-1">核心分类</p>
          </div>
        </div>
      </div>
    </section>
  );
}